import React from 'react'
import moment from 'moment'
import AccountSubsection from './AccountSubsection'
import AccountButton from './AccountButton'

// August 19, 2018
function formatTimestamp(timestamp) {
  return moment(timestamp).format('MMMM DD, YYYY')
}

function checkIfPastDue(paidUntil) {
  if (!paidUntil) return false
  // stripe waits an hour to finalize the invoice and charge the payment method
  // the payment process might take some time
  // so we give the user an extra day before marking the account as past due
  const paidUntilPlusBuffer = moment(paidUntil).add(1, 'days')
  return moment().isAfter(paidUntilPlusBuffer)
}

class AccountServiceStatusPaymentInfo extends React.Component {
  render() {
    const { billingInfo, openBillingPortal } = this.props
    if (billingInfo) {
      const cardInfo = billingInfo.card || {}
      return (
        <React.Fragment>
          {`${cardInfo.brand} •••• •••• •••• ${cardInfo.last4}`}
          <div className='account-serviceStatus-sub'>
            {this.props.currentSubscriptionPrice}
            /
            {this.props.currentSubscriptionBillingPeriod}
          </div>
          <AccountButton label='Manage Payment Methods' onClickFunction={openBillingPortal} />
        </React.Fragment>
      )
    } return null
  }
}

class AccountServiceStatus extends React.Component {
  showUpgradeModal() {
    window.location.hash = 'upgrade'
  }

  render() {
    const {
      showDowngradePlanModal, accountServiceStatus, service, previewInvoice, billingInfo,
    } = this.props

    // ACTIVE
    const nextPaymentDate = previewInvoice ? formatTimestamp(previewInvoice.date) : ''
    const currentSubscriptionPrice = previewInvoice ? `$${(previewInvoice.amountDue / 100).toFixed(2)}` : ''
    let currentSubscriptionBillingPeriod = ''
    if (previewInvoice) {
      currentSubscriptionBillingPeriod = previewInvoice.plan === process.env.REACT_APP_STRIPE_MONTHLY_PLAN_ID ? 'month' : 'year'
    }

    // PAST DUE
    const isPastDue = ['active', 'trial'].includes(accountServiceStatus) && checkIfPastDue(service?.paidUntil)

    // CANCELLED
    const downgradeDate = formatTimestamp(service.paidUntil)

    // PASS
    const passProvidedBy = service.providedBy

    let paymentDateDisplayString = `Next payment: ${nextPaymentDate}`
    let downgradeTitle = 'Downgrade to Free Plan'
    if (isPastDue) {
      paymentDateDisplayString = `Invoice date: ${formatTimestamp(service.paidUntil)}`
    } else if (accountServiceStatus === 'trial') {
      paymentDateDisplayString = `Trial ends: ${formatTimestamp(service.paidUntil)}`
      downgradeTitle = 'Cancel Trial'
    }

    return (

      <React.Fragment>

        {accountServiceStatus === 'free' && (
        <AccountSubsection label='Plan'>
          Plickers Free
          <div className='account-subsection-actionRow'>
            <AccountButton label='Upgrade to Pro' onClickFunction={this.showUpgradeModal} />
            <AccountButton label='Add License Key' onClickFunction={this.props.showAddLicenseKeyModal} />
            {billingInfo && (
            <React.Fragment>
              <AccountButton label='View Billing History' onClickFunction={this.props.showBillingInfoModal} />
              <AccountButton label='Manage Payment Methods' onClickFunction={this.props.openBillingPortal} />
            </React.Fragment>
            )}
          </div>
        </AccountSubsection>
        )}

        {['active', 'trial'].includes(accountServiceStatus) && (
        <div className='account-subsectionContainer--twoColumn'>
          <AccountSubsection twoColumn label='Plan'>
            Plickers Pro
            {(isPastDue || accountServiceStatus === 'trial') && (
              <React.Fragment>
                {' '}
                <div
                  className={`account-serviceStatus-pill account-serviceStatus-pill--${isPastDue ? 'pastDue' : 'trial'}`}
                >
                  {isPastDue ? 'Past Due' : 'Trial'}
                </div>
              </React.Fragment>
            )}
            <div className='account-serviceStatus-sub'>
              {paymentDateDisplayString}
            </div>
            {accountServiceStatus === 'active' &&
            <AccountButton label='View Billing History' onClickFunction={this.props.showBillingInfoModal} />}
            <AccountButton label='Add License Key' onClickFunction={this.props.showAddLicenseKeyModal} />
            <AccountButton label={downgradeTitle} onClickFunction={showDowngradePlanModal} />
          </AccountSubsection>

          <AccountSubsection twoColumn label='Payment Info'>
            <AccountServiceStatusPaymentInfo
              billingInfo={billingInfo}
              currentSubscriptionPrice={currentSubscriptionPrice}
              currentSubscriptionBillingPeriod={currentSubscriptionBillingPeriod}
              openBillingPortal={this.props.openBillingPortal}
            />
            <AccountButton label='Change Billing Period' onClickFunction={this.props.showSwitchPlanModal} />
          </AccountSubsection>
        </div>
        )}

        {accountServiceStatus === 'canceled' && (
        <AccountSubsection label='Plan'>
          Plickers Pro
          {' '}
          <div className='account-serviceStatus-pill account-serviceStatus-pill--cancelled'>Cancelled</div>
          <div className='account-serviceStatus-sub'>
            You will lose access to Plickers Pro on
            {' '}
            {downgradeDate}
          </div>
          <div className='account-subsection-actionRow'>
            <AccountButton label='Keep Plickers Pro' onClickFunction={this.props.showRevertProCancellationModal} />
            <AccountButton label='View Billing History' onClickFunction={this.props.showBillingInfoModal} />
            <AccountButton label='Manage Payment Methods' onClickFunction={this.props.openBillingPortal} />
            <AccountButton label='Add License Key' onClickFunction={this.props.showAddLicenseKeyModal} />
          </div>
        </AccountSubsection>
        )}

        {accountServiceStatus === 'pass' && (
        <AccountSubsection label='Plan'>
          Plickers Pro
          <div className='account-serviceStatus-sub'>
            Your subscription is provided by
            {' '}
            <span className='account-serviceStatus--pass-providedBy'>{passProvidedBy}</span>
            .
          </div>
          <div className='account-subsection-actionRow'>
            <AccountButton label='Add License Key' subtle onClickFunction={this.props.showAddLicenseKeyModal} />
            {billingInfo && (
            <React.Fragment>
              <AccountButton label='View Billing History' onClickFunction={this.props.showBillingInfoModal} />
              <AccountButton label='Manage Payment Methods' onClickFunction={this.props.openBillingPortal} />
            </React.Fragment>
            )}
          </div>
        </AccountSubsection>
        )}

      </React.Fragment>
    )
  }
}

export default AccountServiceStatus
